<ion-header>
    <ion-toolbar>
        <ion-title>{{ 'Create team match' | translate }}</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="close()">
                <ion-icon slot="end" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content>
    <form [formGroup]="form">
        <ion-list>
            <ion-item>
                <ion-select label="{{ 'Sport' | translate}}" label-placement="stacked" value="TENNIS" placeholder="Select sport" interface="popover" formControlName="discipline">
                    <ion-select-option value="TENNIS">Tennis</ion-select-option>
                    <ion-select-option value="PADEL">Padel</ion-select-option>
                    <ion-select-option value="PICKLEBALL">Pickleball</ion-select-option>      
                    @if(authService.authUserSignal()?.role?.value > 399) {                    
                        <ion-select-option value="BADMINTON">Badminton</ion-select-option>
                        <ion-select-option value="TABLE_TENNIS">Table Tennis</ion-select-option>
                        <ion-select-option value="SQUASH">Squash</ion-select-option>
                    }
                </ion-select>
            </ion-item>

            <app-datetime-item
                formControlName="startDate"
                [presentation]="'date-time'"
                [minuteValues]="'0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55'"
                [label]="'Start time' | translate">
            </app-datetime-item>

            <ion-item (click)="selectTeam(1)">
                <ion-input label="{{ 'Home team' | translate}}" label-placement="floating" [value]="team1Name" type="text" readonly name="team1"></ion-input>
            </ion-item>

            <ion-item (click)="selectTeam(2)">
                <ion-input label="{{ 'Away team' | translate}}" label-placement="floating" [value]="team2Name" type="text" readonly name="team2"></ion-input>
            </ion-item>

            <app-add-template (selectedSubtype)="addTemplate($event)"></app-add-template>

            @if(!this.isHidePolicy && this.authService.authUserSignal()?.role?.value > 399){
                <ion-item-divider color="light">
                    <ion-label>{{ 'Select policy' | translate }}</ion-label>
                </ion-item-divider>

                <ion-item>
                    <ion-select label="{{'Policy' | translate}}" interface="popover" placeholder="{{'Select policy' | translate}}" formControlName="policy" (ionChange)="onPolicySelected($event)">
                      @for (p of policyList; track $index;) {
                        <ion-select-option [value]="p._id">{{ p.name }}</ion-select-option>
                      }
                    </ion-select>
                </ion-item>
            }

            <ion-item *ngIf="team1Name && team2Name">
                 <ion-toggle formControlName="applyLineup">{{ 'Add lineup' | translate }}</ion-toggle>
            </ion-item>

        </ion-list>
    </form>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button (click)="submit()" expand="block" class="ion-margin">
             <span *ngIf="!isLoading">{{ 'Submit' | translate }}</span>
            <ion-spinner name="crescent" *ngIf="isLoading"></ion-spinner>
        </ion-button>
    </ion-toolbar>
</ion-footer>